/** Invitation composition distinguishes creation, delivery and interrupted recovery. */
export const teamCreateEn={
 "team.create.draftFailed":"The draft could not be restored or saved safely. Any previously saved draft is kept; this tab may have unsaved changes. Close and reopen to retry, or restore access to the selected records.",
 "team.create.discard":"Discard saved draft",
 "team.create.discardWarning":"Discard this saved form? This does not revoke any invitation already created.",
 "team.create.permissions":"Granted permissions",
 "team.create.noPermissions":"This role grants no feature permissions.",
 "team.create.title": "Invite member",
 "team.create.selected": "Selected",
 "team.create.days": "Expires in days",
 "team.create.review": "Review access",
 "team.create.confirm": "Create invitation",
 "team.create.retry": "Retry same invitation",
 "team.create.created": "Invitation created. No email has been sent.",
 "team.create.copy": "Copy invitation link",
 "team.create.copied": "Link copied",
 "team.create.linkNote": "This tab keeps the invitation link. Email or copy it before closing. If the tab closes before you finish, review and revoke the unfinished invitation before creating a replacement.",
 "team.create.failed": "Could not confirm the result. Your current request is preserved in this tab. Retry the same invitation, or close and review its status.",
 "team.create.recovery": "An invitation was started in another view. Its link is no longer available here. Review its status and revoke it before creating a replacement.",
 "team.create.recover": "Review unfinished invitation",
 "team.create.dismiss": "Dismiss recovery reminder",
 "team.create.dismissWarning": "Dismiss this local reminder? This does not revoke an invitation. Check the invitation directory before creating a replacement.",
 "team.email.send":"Email invitation",
 "team.email.sending":"Sending email…",
 "team.email.accepted":"Invitation emailed. The mail server accepted it; arrival in the inbox is not confirmed.",
 "team.email.failed":"The email was not sent. Try again or copy the link instead.",
 "team.email.unknown":"The email may have been sent. Check with the recipient before sending another copy.",
 "team.email.inProgress":"This invitation email is still being sent. Check again in a moment.",
 "team.email.noAnswer":"No answer from the server. The email may have been sent. Check its status before trying again.",
 "team.email.check":"Check email status",
 "team.email.again":"Send another copy",
 "team.email.againWarning":"Send another copy of this invitation email? The recipient may already have one.",
 "team.email.retry":"Try sending again",
 "team.email.notPending":"This invitation is no longer pending, so it can't be emailed.",
 "team.email.denied":"You can no longer email this invitation.",
 "team.email.rateLimited":"Too many invitation emails right now. Try again in a minute.",
 "team.email.unavailable":"Email isn't available here. Copy the link instead.",
 "team.choices.search":"Search…"
};
/** Russian invitation composition and recovery. */
export const teamCreateRu={
 "team.create.draftFailed":"Не удалось безопасно восстановить или сохранить черновик. Ранее сохранённая версия остаётся; в этой вкладке могут быть несохранённые изменения. Закройте и откройте форму снова или восстановите доступ к выбранным записям.",
 "team.create.discard":"Удалить сохранённый черновик",
 "team.create.discardWarning":"Удалить сохранённую форму? Уже созданные приглашения не будут отозваны.",
 "team.create.permissions":"Предоставляемые разрешения",
 "team.create.noPermissions":"Эта роль не предоставляет разрешений на функции.",
 "team.create.title": "Пригласить участника",
 "team.create.selected": "Выбрано",
 "team.create.days": "Срок в днях",
 "team.create.review": "Проверить доступ",
 "team.create.confirm": "Создать приглашение",
 "team.create.retry": "Повторить это приглашение",
 "team.create.created": "Приглашение создано. Письмо не отправлено.",
 "team.create.copy": "Копировать ссылку приглашения",
 "team.create.copied": "Ссылка скопирована",
 "team.create.linkNote": "Ссылка хранится в этой вкладке. Отправьте её по почте или скопируйте перед закрытием. Если вкладка закроется раньше, проверьте и отзовите незавершённое приглашение перед созданием нового.",
 "team.create.failed": "Не удалось подтвердить результат. Текущий запрос сохранён в этой вкладке. Повторите его или закройте форму и проверьте статус.",
 "team.create.recovery": "Приглашение было начато в другом представлении. Его ссылка здесь недоступна. Проверьте статус и отзовите его перед созданием нового.",
 "team.create.recover": "Проверить незавершённое приглашение",
 "team.create.dismiss": "Убрать напоминание",
 "team.create.dismissWarning": "Убрать это локальное напоминание? Приглашение не будет отозвано. Проверьте список приглашений перед созданием нового.",
 "team.email.send":"Отправить приглашение по почте",
 "team.email.sending":"Отправка письма…",
 "team.email.accepted":"Приглашение отправлено. Почтовый сервер принял письмо; доставка во входящие не подтверждена.",
 "team.email.failed":"Письмо не отправлено. Повторите попытку или скопируйте ссылку.",
 "team.email.unknown":"Письмо могло быть отправлено. Уточните у получателя, прежде чем отправлять ещё одну копию.",
 "team.email.inProgress":"Письмо с приглашением ещё отправляется. Проверьте снова через минуту.",
 "team.email.noAnswer":"Сервер не ответил. Письмо могло быть отправлено. Проверьте статус перед повторной попыткой.",
 "team.email.check":"Проверить статус письма",
 "team.email.again":"Отправить ещё одну копию",
 "team.email.againWarning":"Отправить ещё одну копию письма с приглашением? У получателя оно может уже быть.",
 "team.email.retry":"Отправить снова",
 "team.email.notPending":"Приглашение больше не ожидает ответа, поэтому его нельзя отправить.",
 "team.email.denied":"Вы больше не можете отправить это приглашение.",
 "team.email.rateLimited":"Слишком много писем с приглашениями. Повторите через минуту.",
 "team.email.unavailable":"Отправка почты здесь недоступна. Скопируйте ссылку.",
 "team.choices.search":"Поиск…"
};
/** Korean invitation composition and recovery. */
export const teamCreateKo={
 "team.create.draftFailed":"초안을 안전하게 복원하거나 저장하지 못했습니다. 이전에 저장된 초안은 유지되지만 이 탭에 저장되지 않은 변경 사항이 있을 수 있습니다. 닫았다 다시 열거나 선택한 기록의 접근 권한을 복구하세요.",
 "team.create.discard":"저장된 초안 삭제",
 "team.create.discardWarning":"저장된 양식을 삭제할까요? 이미 생성된 초대는 철회되지 않습니다.",
 "team.create.permissions":"부여되는 권한",
 "team.create.noPermissions":"이 역할은 기능 권한을 부여하지 않습니다.",
 "team.create.title": "구성원 초대",
 "team.create.selected": "선택됨",
 "team.create.days": "만료까지 일수",
 "team.create.review": "접근 권한 검토",
 "team.create.confirm": "초대 생성",
 "team.create.retry": "같은 초대 재시도",
 "team.create.created": "초대가 생성되었습니다. 이메일은 전송되지 않았습니다.",
 "team.create.copy": "초대 링크 복사",
 "team.create.copied": "링크 복사됨",
 "team.create.linkNote": "초대 링크는 이 탭에 보관됩니다. 닫기 전에 이메일로 보내거나 복사하세요. 완료 전에 탭이 닫히면 새 초대를 만들기 전에 미완료 초대를 확인하고 철회하세요.",
 "team.create.failed": "결과를 확인하지 못했습니다. 현재 요청은 이 탭에 보존됩니다. 같은 초대를 재시도하거나 닫은 후 상태를 확인하세요.",
 "team.create.recovery": "다른 화면에서 초대를 시작했습니다. 여기서는 해당 링크를 사용할 수 없습니다. 새 초대를 만들기 전에 상태를 확인하고 철회하세요.",
 "team.create.recover": "미완료 초대 확인",
 "team.create.dismiss": "복구 알림 닫기",
 "team.create.dismissWarning": "이 로컬 알림을 닫을까요? 초대는 철회되지 않습니다. 새 초대를 만들기 전에 초대 목록을 확인하세요.",
 "team.email.send":"이메일로 초대 보내기",
 "team.email.sending":"이메일 보내는 중…",
 "team.email.accepted":"초대 이메일을 보냈습니다. 메일 서버가 수락했으며 받은편지함 도착은 확인되지 않았습니다.",
 "team.email.failed":"이메일을 보내지 못했습니다. 다시 시도하거나 링크를 복사하세요.",
 "team.email.unknown":"이메일이 전송되었을 수 있습니다. 다른 사본을 보내기 전에 받는 사람에게 확인하세요.",
 "team.email.inProgress":"초대 이메일을 아직 보내는 중입니다. 잠시 후 다시 확인하세요.",
 "team.email.noAnswer":"서버 응답이 없습니다. 이메일이 전송되었을 수 있습니다. 다시 시도하기 전에 상태를 확인하세요.",
 "team.email.check":"이메일 상태 확인",
 "team.email.again":"사본 한 통 더 보내기",
 "team.email.againWarning":"초대 이메일 사본을 한 통 더 보낼까요? 받는 사람이 이미 받았을 수 있습니다.",
 "team.email.retry":"다시 보내기",
 "team.email.notPending":"이 초대는 더 이상 대기 중이 아니므로 이메일로 보낼 수 없습니다.",
 "team.email.denied":"이 초대를 더 이상 이메일로 보낼 수 없습니다.",
 "team.email.rateLimited":"초대 이메일이 너무 많습니다. 1분 후 다시 시도하세요.",
 "team.email.unavailable":"여기서는 이메일을 사용할 수 없습니다. 대신 링크를 복사하세요.",
 "team.choices.search":"검색…"
};
